module.exports = __webpack_public_path__ + "media/images/icons/outlined/dollar-e7911c2b6a0c5fb6042f54f79cd0d508.svg";